// Development environment configuration
export const environment = {
  production: false,
  config: {
    formularios: 'https://qa.tecfinanzas.com/TFMFormularios/',
    Server: 'https://qa.tecfinanzas.com/',
    Servidor: 'https://qa.tecfinanzas.com/',
    ServidorContable: 'https://qa.tecfinanzas.com/TFMContable/',
    ServidorDocumentos: 'https://tfnbx-platform-dev.azure-api.net/documents/',
    ServidorDocumentosLegacy: 'https://qa.tecfinanzas.com/TFMDocumentos/',
    ServidorExternos: 'https://qa.tecfinanzas.com/TFMExternos/',
    ServidorM3: 'https://qa.tecfinanzas.com/TFMM3/',
    ServidorPersonas: 'https://qa.tecfinanzas.com/TFMPersonas/',
    ServidorPrestamo: 'https://qa.tecfinanzas.com/TFMPrestamos/',
    ServidorIntegraciones: 'https://we11integracionesprod.azurewebsites.net',
    WebUtilities: 'https://qa.tecfinanzas.com/Formularios/#/',
    WebBase: 'https://qa.tecfinanzas.com/Formularios',
    ServerUploadFiles: 'https://tfnbx-platform-dev.azure-api.net/forms/',
    ServerScUtilities: 'https://tfnbx-platform-dev.azure-api.net/general',
    BlobUrl: 'https://tfnbxstoragedev.blob.core.windows.net/forms-documents/temp/',
    DocumentIntelligenceUrl: 'https://tfnbx-ai-svc-dev.azurewebsites.net/document-intelligence/analyze/',
    DocumentBlob: 'https://tfnbxstoragedev.blob.core.windows.net/tfm-documents',
    ServidorAuth: 'https://tfnbx-platform-dev.azure-api.net/auth/',
    ServidorPeople: 'https://tfnbx-platform-dev.azure-api.net/people/'
  },
};
